export default {
  isLoading: state => state.loading,
  getLoading: state => state.loading,
  getStatus: state => state.status,
  getMessage: state => state.message,
  getErrorCode: state => state.errorCode,
  getNextPage: state => state.nextPage,
  getToggleManageMembership: state => state.toggleManageMembership,
};



// WEBPACK FOOTER //
// ./src/stores/Notification/getters/index.js